import React from 'react';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CalculateIcon from '@mui/icons-material/Calculate';
import { PsfColors } from '../theme';

export interface PsfValueDetail {
  label: string;
  formula: string;
  amount: string;
}

export default function PsfValueDetailDialog({ detail, c, onClose }: {
  detail: PsfValueDetail | null;
  c: PsfColors;
  onClose: () => void;
}) {
  return (
    <Dialog
      open={Boolean(detail)}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{ sx: { bgcolor: c.surfaceCard, color: c.text, border: `1px solid ${c.border}`, borderRadius: 2 } }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, pr: 6 }}>
        <CalculateIcon sx={{ color: c.yellow, fontSize: 19 }} />
        <Typography sx={{ fontWeight: 800, fontSize: '0.92rem', flex: 1 }}>
          {detail?.label || 'Calculation'}
        </Typography>
        <IconButton
          aria-label="Close calculation"
          onClick={onClose}
          sx={{ color: c.textMuted, position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ borderColor: c.border }}>
        {detail && (
          <Box sx={{ bgcolor: `${c.yellow}12`, borderRadius: 1.5, p: 1.5 }}>
            <Typography sx={{ color: c.textMuted, fontSize: '0.68rem', mb: 0.75 }}>
              Formula and result
            </Typography>
            <Typography sx={{ color: c.text, fontFamily: 'monospace', fontSize: '0.8rem', lineHeight: 1.6, overflowWrap: 'anywhere' }}>
              {detail.formula}
            </Typography>
            <Typography sx={{ color: c.yellow, fontSize: '1rem', fontWeight: 800, textAlign: 'right', mt: 1 }}>
              {detail.amount}
            </Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}
